import React, { useState, useEffect } from 'react';
import Skeleton from 'react-loading-skeleton';

import { PProFetch } from '../ajax';

export default function OpenInvoices(props) {
	const { refreshSignal, CacheKey } = props;
	const cache = JSON.parse(window.localStorage.getItem("ecom_OpenInvoices_invoicePayment.optionsreact"));
	const cacheStamp = cache ? Date.parse(cache.stamp) : null;
	const localKey = cache ? cache.key : null;
	const [fpInfo, setFpInfo] = useState({
		root: {
			INVOICE_INSTRUCTIONS: null,
			VIEWONLY: null,
			PARTIALALLOWED: null,
			RDONLY: null,
			TOTAL: null
		},
		rowData: {
			/*
			CNAME
			IVNO
			NODETAILLINKCLASS
			SONO
			DETAILURL
			IVDT
			DUDT
			CUST
			COMP
			REFR
			IVAM
			BLDSP
			BLAM
			BLCSS
			*/
		}
	});
	const [tableView, setTableView] = useState({
		field: "",
		ascending: false,
		suffixes: []
	});
	const [loading, setLoading] = useState(true);

	const updateStateFromAjax = (json) => {
		setFpInfo({...json});
		setLoading(false);
		setTableView({
			...tableView,
			suffixes: Object.keys(json.rowData)
		});
	}

	useEffect(() => {
		setLoading(true);
		if (
			/* if manual refresh signal is incremented, refresh */
			refreshSignal > 0 ||
			(	/* or if cache is too old, refresh */
				!cacheStamp || ((new Date() - cacheStamp) > (5*60*1000))
			) || (
				/* or if cache key has changed, refresh */
				!localKey || localKey != CacheKey
			)
		) {
			PProFetch("command=invoicePayment.optionsreact")
			.then(response => {
				return response.json();
			})
			.then(json => {
				updateStateFromAjax(json);
				window.localStorage.setItem("ecom_OpenInvoices_invoicePayment.optionsreact", JSON.stringify({
					stamp: new Date(),
					key: CacheKey,
					data: {...json}
				}));
			});
		} else {
			updateStateFromAjax(cache.data);
		}
	}, [refreshSignal]);

	const manageFieldEntry = () => {
		console.log("manageFieldEntry", arguments);
	}
	const validateFixedAmount = () => {
		console.log("validateFixedAmount", arguments);
	}
	const validatePaymentChoice = () => {
		console.log("validatePaymentChoice", arguments);
	}
	const payFullAmount = () => {
		console.log("payFullAmount", arguments);
	}

	const sortCol = (field) => {
		let ascending = false;
		if (tableView.field === field) {
			ascending = !tableView.ascending;
		}
		const suffixes = Object.keys(fpInfo.rowData);
		let sortedData = suffixes.map((suffix) => ({data: fpInfo.rowData[suffix], suffix}));
		let compare = (a, b) => {
			if (a.data[field].value < b.data[field].value) {
			return ascending ? -1 : 1;
			}
			if (a.data[field].value > b.data[field].value) {
			return ascending ? 1 : -1;
			}
			return 0;
		};
		sortedData.sort(compare);
		const newSortSuffixes = [];
		for (let i = 0; i < sortedData.length; i++) {
			newSortSuffixes[i] = sortedData[i].suffix;
		}
		console.log(newSortSuffixes);
		setTableView({
			field,
			ascending,
			suffixes: newSortSuffixes
		});
	}

	const tableFilter = (event) => {
		const val = event.target.value;
		if (!val || !val.trim()) {
			//clear, buggy
			setTableView({
				...tableView,
				suffixes: Object.keys(fpInfo.rowData)
			});
		}
		let sortedData = [];
		for (let [suffix, rowData] of Object.entries(fpInfo.rowData)) {
			for (let field of Object.values(rowData)) {
				if (field.value && field.value.toLowerCase().includes(val.toLowerCase())) {
					sortedData.push(suffix);
					break;
				}
			}
		}
		setTableView({
			...tableView,
			suffixes: sortedData
		});
	}

	let table = null;
	if (loading) {
		table = (<Skeleton count={5} height="45px"/>);
	} else {
		const rows = new Array();
		for (let suffix of tableView.suffixes) {
			const thisRowData = fpInfo.rowData[suffix];
			rows.push(
				<tr key={suffix}>
					<td className="invoice__customer">{thisRowData.CNAME.value}</td>
					<td className="invoice__no">{thisRowData.IVNO.value}</td>
					<td className="invoice__ponumber">{thisRowData.SONO.value}</td>
					<td className="invoice__date">{thisRowData.IVDT.value}</td>
					<td className="invoice__duedate">{thisRowData.DUDT.value}</td>
					<td className="invoice__amount text-end">${thisRowData.IVAM.value}</td>
					<td className="invoice__balance text-end">${thisRowData.BLDSP.value}</td>
				</tr>
			);
		}
		table = (
			<table id="openinvoices" className="openinvoices table" data-toggle="table" data-pagination="true" data-sort-stable="true">
				<thead className="bg-color--light">
					<tr>
						<th className="invoice__customer" onClick={() => sortCol("CNAME")}>Customer</th>
						<th className="invoice__no" onClick={() => sortCol("IVNO")}>Invoice No.</th>
						<th className="invoice__ponumber" onClick={() => sortCol("SONO")}>PO Number</th>
						<th className="invoice__date" onClick={() => sortCol("IVDT")}>Invoice Date</th>
						<th className="invoice__duedate" onClick={() => sortCol("DUDT")}>Due Date</th>
						<th className="invoice__amount right" onClick={() => sortCol("IVAM")}>Invoice Amount</th>
						<th className="invoice__balance right" onClick={() => sortCol("BLDSP")}>Invoice Balance</th>
					</tr>
				</thead>
				<tbody>
					{rows}
				</tbody>
				<tfoot>
					<tr id="totalsrow" style={{textAlign: "right"}}>
						<td className="invoice__customer"></td>
						<td className="invoice__no"><strong>TOTAL:</strong></td>
						<td className="invoice__ponumber"></td>
						<td className="invoice__date"></td>
						<td className="invoice__duedate"></td>
						<td className="invoice__amount right"></td>
						<td className="invoice__balance right"><strong id="spanbottomtotamt">${parseFloat(fpInfo.root.TOTAL.value).toLocaleString('en-US', {style: 'decimal', minimumFractionDigits: 2,  maximumFractionDigits: 2})}</strong></td>
					</tr>
				</tfoot>
			</table>
		);
	}
	return (
		<React.Fragment>
			<div className="d-flex justify-content-end mb-md1">
				<div className="search__wrapper border rounded-3 border-gray3 position-relative">
					<input type="text" className="input--small border-0 bg-transparent ps-3 pe-5 py-2" placeholder="Search invoices" onChange={(e) => tableFilter(e)}/>
					<button type="submit" className="search-submit position-absolute top-50 translate-middle-y pe-2">
						<svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 38.6 38.6" xmlSpace="preserve">
							<path className="primary" d="M25.8,23.6c2.1-2.6,3.2-5.8,3.2-9.1C29,6.5,22.5,0,14.5,0S0,6.5,0,14.5S6.5,29,14.5,29c3.3,0,6.5-1.2,9.1-3.2 l12.9,12.9l2.1-2.1L25.8,23.6z M14.5,3C20.8,3,26,8.2,26,14.5S20.8,26,14.5,26S3,20.8,3,14.5S8.2,3,14.5,3z"></path>
						</svg>
					</button>
				</div>
			</div>
			<div className="invoice-table table__wrapper overflow-auto">
				{table}
			</div>
		</React.Fragment>
	);
}